<ngb-alert *ngIf="loggedUser.hideMessage.getValue()"
           type="custom"
           [class.mb-0]="marginBottom"
           [dismissible]="false">
    You are currently logged as {{ userName }}.
    If you want to login with your account, please remove the login as in the profile icon dropdown
    <button class="btn btn-secondary btn-sm btn-square m-2"
            (click)="onRemoveLoggedIn()">
      Remove login as
    </button>
</ngb-alert>
